import { type ReactElement } from 'react';
import { CatalogId } from '@kirin/api-client/contracts/ai-instruction-catalog';
import { CatalogModePage, type CatalogModePageProps } from './CatalogModePage';

type SecureAiCodingEnforcementPageProps = Omit<CatalogModePageProps, 'catalog'>;

/**
 * KIR-3816: the top-level Secure AI Coding Enforcement page — the full
 * four-framework catalog whose mode drives the scanner-less
 * `ai-instruction-catalog` policy. Thin call site over {@link CatalogModePage}.
 */
export function SecureAiCodingEnforcementPage(
  props: SecureAiCodingEnforcementPageProps
): ReactElement {
  return <CatalogModePage catalog={CatalogId.SecureCoding} {...props} />;
}
